import axios from 'axios';
import { API_URL, CLOUD_API_URL } from '../config';
import { isIdentityPath } from './identityRoutes';

// Account requests go to our cloud rather than to this installation — see CLOUD_API_URL in config.js
// for why that needs no credential here. The rule itself lives in identityRoutes.js so it can be run
// and checked on its own.
const isIdentityRequest = (url) => Boolean(CLOUD_API_URL) && isIdentityPath(url);

let iframeToken = null;
let iframeOrgId = null;

const instance = axios.create({
  headers: { 'Content-Type': 'application/json' },
  baseURL: API_URL,

});  

export const setIframeApiConfig = (token, orgId) => {
  iframeToken = token;
  iframeOrgId = orgId;
};

const verifyToken = () => {
  // const tokenParsed = keycloak? keycloak.tokenParsed : null;
  // const currTime = new Date().getTime() / 1000
  // if (!tokenParsed || !tokenParsed.auth_time ||
  //       ( currTime - tokenParsed.auth_time) > (tokenParsed.exp - tokenParsed.iat) ||
  //       ( currTime > tokenParsed.exp)) {
  //   keycloak.logout()
  // }
};

const onBeforeRequestSent = (config) => {
  verifyToken();
  // Set per request rather than on the instance, because the same axios instance serves both. The
  // headers below are unchanged either way: the cloud authenticates the very same idtoken, since both
  // deployments validate against one Cognito pool — which is what makes this work with no credential
  // on the box.
  if (isIdentityRequest(config.url)) config.baseURL = CLOUD_API_URL; // eslint-disable-line no-param-reassign
  const { idToken, orgId, apikey } = window.localStorage;
  config.headers.idtoken = iframeToken || idToken; // eslint-disable-line no-param-reassign
  config.headers.orgId ??= iframeOrgId || orgId; // eslint-disable-line no-param-reassign
  config.headers.apikey = apikey; // eslint-disable-line no-param-reassign
  config.headers.iframe = !!iframeToken; // eslint-disable-line no-param-reassign
  return config;
};

const onRequestError = (error) => {
  console.log('error', error);
  return error;
};  

// --- 4. 401 Handling (The Auto-Refresh Magic) ---
const onResponseError = async (error) => {
  const originalRequest = error.config;
  // If error is 401 and we haven't retried yet
  if (error.response?.status === 401 && !originalRequest._retry) { // eslint-disable-line no-underscore-dangle
    // originalRequest._retry = true;

    // 1. Notify Parent App that token expired
    window.parent.postMessage({ type: 'TOKEN_EXPIRED' }, '*');

    // 2. Create a Promise that waits for the new token
    // This pauses the failed request until the parent responds
    return new Promise((resolve, reject) => {
      const handleMessage = (event) => {
        // Security check: ensure it comes from trusted parent
        // if (event.origin !== "https://customer-app.com") return;

        if (event.data.type === 'NEW_TOKEN') {
          console.log('onResponseError:: Received new token from parent', event.data);
          // A. Update our local memory
          setIframeApiConfig(event.data.iframeToken, event.data.iframeOrgId || originalRequest.headers);

          // B. Update the failed request header
          originalRequest.headers.idtoken = event.data.iframeToken;

          // C. Cleanup and Retry
          window.removeEventListener('message', handleMessage);
          resolve(instance(originalRequest));
        }
      };

      // Listen for the response
      window.addEventListener('message', handleMessage);

      // Safety: Reject if no response after 5 seconds
      setTimeout(() => {
        console.log('onResponseError:: Timeout waiting for new token from parent');
        window.removeEventListener('message', handleMessage);
        reject(error);
      }, 5000);
    });
  }

  return Promise.reject(error);
};

// interceptor
instance.interceptors.request.use(onBeforeRequestSent, onRequestError);
instance.interceptors.response.use((response) => response, onResponseError);

const API = instance;

export default API;
